var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "navbar" },
    [
      _c("div", { staticClass: "navbar-inner" }, [
        _c(
          "div",
          { staticClass: "left-menu" },
          [
            _c(
              "div",
              {
                staticClass: "toggle-btn",
                on: {
                  click: function ($event) {
                    return _vm.changeIsCollapse(!_vm.getIsOpenCloseManu)
                  },
                },
              },
              [
                _c("i", {
                  class: _vm.getIsOpenCloseManu
                    ? "el-icon-s-unfold"
                    : "el-icon-s-fold",
                }),
              ]
            ),
            _c(
              "el-breadcrumb",
              {
                staticClass: "custom-breadcrumb",
                attrs: { "separator-class": "el-icon-arrow-right" },
              },
              [
                _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                  _c("span", { staticClass: "home-text" }, [
                    _vm._v("Trang chủ"),
                  ]),
                ]),
                _vm._l(_vm.getBreadcrumbDataList, function (item, index) {
                  return _c(
                    "el-breadcrumb-item",
                    {
                      key: index,
                      attrs: { to: { path: item.url } },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.handleBreadcrumbClick(item)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n            " + _vm._s(item.name) + "\n          "
                      ),
                    ]
                  )
                }),
              ],
              2
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "right-menu" },
          [
            _vm.getAppTypeUserLogin === _vm.appType.SUPPER_SCHOOL ||
            _vm.getAppTypeUserLogin === _vm.appType.SCHOOL ||
            _vm.getAppTypeUserLogin === _vm.appType.TEACHER ||
            _vm.getAppTypeUserLogin === _vm.appType.PARENT
              ? _c("span", { staticClass: "school-name" }, [
                  _vm._v(_vm._s(_vm.getDataSchool.schoolName)),
                ])
              : _vm._e(),
            _c("div", { staticClass: "vertical-divider" }),
            _c(
              "el-popover",
              {
                attrs: {
                  placement: "bottom-end",
                  trigger: "click",
                  "popper-class": "premium-user-popper",
                  "visible-arrow": false,
                  width: "300",
                },
                scopedSlots: _vm._u([
                  {
                    key: "reference",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "profile-trigger",
                            class: { active: _vm.showUserMenu },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "avatar-mini-box" },
                              [
                                _c("el-image", {
                                  staticClass: "avatar-mini",
                                  attrs: { src: _vm.getAvatar },
                                }),
                              ],
                              1
                            ),
                            _c("span", { staticClass: "username-text" }, [
                              _vm._v(_vm._s(_vm.getUserLogin)),
                            ]),
                            _c("i", {
                              staticClass: "el-icon-arrow-down caret-icon",
                            }),
                          ]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.showUserMenu,
                  callback: function ($$v) {
                    _vm.showUserMenu = $$v
                  },
                  expression: "showUserMenu",
                },
              },
              [
                _c("div", { staticClass: "user-card" }, [
                  _c("div", { staticClass: "user-card-header" }, [
                    _c(
                      "div",
                      { staticClass: "avatar-big-wrapper" },
                      [
                        _c("el-image", {
                          staticClass: "avatar-big",
                          attrs: { src: _vm.getAvatar },
                        }),
                        _c("div", { staticClass: "status-indicator" }),
                      ],
                      1
                    ),
                    _c("h3", { staticClass: "user-name-display" }, [
                      _vm._v(_vm._s(_vm.getUserLogin)),
                    ]),
                    _c("p", { staticClass: "user-role-display" }, [
                      _vm._v(
                        _vm._s(_vm.getDataSchool.schoolName || "Thành viên")
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "user-card-body" }, [
                    _c(
                      "div",
                      {
                        staticClass: "menu-item-group",
                        on: {
                          click: function ($event) {
                            return _vm.handleDropdow("profileCommand")
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "icon-box blue-gradient" }, [
                          _c("i", { staticClass: "el-icon-user-solid" }),
                        ]),
                        _c("div", { staticClass: "menu-text" }, [
                          _c("span", { staticClass: "main-title" }, [
                            _vm._v("Thông tin & tài khoản"),
                          ]),
                          _c("span", { staticClass: "sub-title" }, [
                            _vm._v("Cập nhật hồ sơ cá nhân"),
                          ]),
                        ]),
                        _c("i", {
                          staticClass: "el-icon-arrow-right arrow-next",
                        }),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "menu-item-group",
                        on: {
                          click: function ($event) {
                            return _vm.handleDropdow("changePasswordCommand")
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "icon-box orange-gradient" }, [
                          _c("i", { staticClass: "el-icon-lock" }),
                        ]),
                        _c("div", { staticClass: "menu-text" }, [
                          _c("span", { staticClass: "main-title" }, [
                            _vm._v("Đổi mật khẩu"),
                          ]),
                          _c("span", { staticClass: "sub-title" }, [
                            _vm._v("Bảo mật tài khoản của bạn"),
                          ]),
                        ]),
                        _c("i", {
                          staticClass: "el-icon-arrow-right arrow-next",
                        }),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "user-card-footer" }, [
                    (_vm.getDataSchool != null &&
                      _vm.getDataSchool.manyStatus &&
                      _vm.getAppTypeUserLogin === _vm.appType.SUPPER_SCHOOL) ||
                    _vm.getAppTypeUserLogin === _vm.appType.SCHOOL ||
                    _vm.getAppTypeUserLogin === _vm.appType.TEACHER ||
                    _vm.getAppTypeUserLogin === _vm.appType.PARENT
                      ? _c(
                          "button",
                          {
                            staticClass: "btn-flat primary",
                            on: {
                              click: function ($event) {
                                return _vm.handleDropdow("changeSchoolCommand")
                              },
                            },
                          },
                          [
                            _c("i", {
                              class:
                                _vm.getAppTypeUserLogin === _vm.appType.PARENT
                                  ? "el-icon-user"
                                  : "el-icon-office-building",
                            }),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.getAppTypeUserLogin === _vm.appType.PARENT
                                    ? "Chọn con"
                                    : "Đổi trường"
                                )
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "button",
                      {
                        staticClass: "btn-flat danger",
                        on: {
                          click: function ($event) {
                            return _vm.logoutDeviceMethod("logoutCommand")
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "el-icon-switch-button" }),
                        _vm._v(" Đăng xuất\n              "),
                      ]
                    ),
                  ]),
                ]),
              ]
            ),
          ],
          1
        ),
      ]),
      _c("ChangePassword", {
        attrs: { dialogVisible: _vm.showCreateDialog },
        on: {
          "dialog-close": function ($event) {
            return _vm.dialogCloseCreateMethod()
          },
        },
      }),
      _c("Profile", {
        ref: "Profile",
        attrs: { dialogVisible: _vm.showProfileDialog },
        on: {
          "dialog-close": function ($event) {
            return _vm.dialogCloseProfileMethod()
          },
        },
      }),
      _c("ChangeSchool", {
        ref: "ChangeSchool",
        attrs: { dialogVisible: _vm.showChangeSchoolDialog },
        on: {
          "dialog-close": function ($event) {
            return _vm.dialogCloseChangeSchoolMethod()
          },
        },
      }),
      _c("ChangeKidsDialog", {
        ref: "ChangeKidsDialog",
        attrs: { dialogVisible: _vm.showChangeKidsDialog },
        on: {
          "dialog-close": function ($event) {
            return _vm.dialogCloseChangeKidsMethod()
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }